"use client";

import React, { useState } from "react";
import { SectionContentProps } from "../../types";
import LogoUploader from "../../sections/header/LogoUploader";
import { PiListBold, PiXBold } from "react-icons/pi";

export default function PortfolioHeader({
  content,
  onContentChange,
  isSelected,
  defaultLogo,
}: SectionContentProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const navItems = content.navItems || ["Work", "About", "Services", "Contact"];

  const handleLogoChange = (newLogoUrl: string) => {
    onContentChange?.({ ...content, logo: newLogoUrl });
  };

  return (
    <header
      className={`w-full transition-all relative z-50 bg-white ${isSelected ? "ring-2 ring-blue-500 z-50" : ""}`}
      style={{ fontFamily }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between py-6">
        <div className="flex items-center flex-shrink-0">
          <LogoUploader
            currentLogo={content.logo}
            defaultLogo={defaultLogo || "Portfolio"}
            onLogoChange={handleLogoChange}
            heightClass="h-8"
            primaryColor="#1E293B"
            secondaryColor="#64748B"
            companyName={content.companyName || "Portfolio"}
            isEditing={!!onContentChange}
          />
        </div>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              className="text-sm font-medium text-slate-500 hover:text-slate-900 transition-colors"
            >
              {item}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <a
            href={content.ctaLink || "#contact"}
            className="text-sm font-bold text-slate-900 hover:underline transition-all"
          >
            {content.ctaText || "Let's Talk"}
          </a>
        </div>

        <div className="md:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-slate-600 hover:text-slate-900 p-2"
          >
            {isMobileMenuOpen ? <PiXBold className="h-6 w-6" /> : <PiListBold className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 py-4 px-6 space-y-4">
          {navItems.map((item: string, idx: number) => (
            <a
              key={idx}
              href={`#${item.toLowerCase()}`}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-slate-500 hover:text-slate-900 py-1"
            >
              {item}
            </a>
          ))}
          <a
            href={content.ctaLink || "#contact"}
            onClick={() => setIsMobileMenuOpen(false)}
            className="block text-center py-2.5 rounded-lg border border-slate-200 text-slate-800 font-bold text-sm"
          >
            {content.ctaText || "Let's Talk"}
          </a>
        </div>
      )}
    </header>
  );
}
